import {Component} from "react";
import * as React from "react";
import CDBBlogCard from "./CDBBlogCard";
import {PrimaryButton} from "office-ui-fabric-react";

const PAGE_SIZE = 20;

export interface BlogPost
{
    date: string;
    title: {rendered: string}
    jetpack_featured_media_url: string;
    link: string;
    excerpt: {protected: boolean,rendered: string}
}

interface CDBBlogViewerProps
{
}

interface CDBBlogViewerState
{
    blogPosts: BlogPost[];
    currentPage: number;
    loading: boolean;
    reachedEnd: boolean;
}

export default class CDBBlogViewer extends Component<CDBBlogViewerProps,CDBBlogViewerState>
{
    constructor(props: Readonly<CDBBlogViewerProps>) {
        super(props);
        
        this.state = {
            blogPosts: [],
            currentPage: 0,
            loading: false,
            reachedEnd: false
        };
    }

    public async componentDidMount() {
        await this.fetchNextPage();
    }
    
    private categoriesToExclude = [1370, 1371];

    private getCategoriesToExclude(): string {
        return `categories_exclude=${this.categoriesToExclude.join(',')}`;
    }
    
    private async fetchNextPage() {

        const nextPageNumber = this.state.currentPage + 1;
        
        this.setState({
            loading: true
        });

        
        let response: Response;
        try
        {
            response = await fetch(`https://clouddesignbox.co.uk/wp-json/wp/v2/posts/?per_page=${PAGE_SIZE}&_fields[]=title&_fields[]=excerpt&_fields[]=jetpack_featured_media_url&_fields[]=date&_fields[]=link&${this.getCategoriesToExclude()}&page=${nextPageNumber}`);
        }
        catch(e)
        {
            console.log("Failed to load blog posts : ");
            console.log(e);
            this.setState({loading: false})
            
            return;
        }
        
        const responseText = await response.text();
        const loadedBlogPosts: BlogPost[] = JSON.parse(responseText) as BlogPost[];

        this.setState({
            blogPosts: [...this.state.blogPosts, ...loadedBlogPosts],
            currentPage: nextPageNumber,
            reachedEnd: loadedBlogPosts.length < PAGE_SIZE,
            loading: false
        });
    }

    public render() {

        if(this.state.blogPosts.length === 0)
        {
            return null;
        }
        
        const cards = this.state.blogPosts.map(bp => <CDBBlogCard key={bp.link} blogPost={bp}/>)
        const showNextPageButton = !this.state.loading && !this.state.reachedEnd;
        
        
        const nextPageButton = (
            <PrimaryButton
                onClick={() => this.fetchNextPage()}
                text="More Posts"/>
        );
        
        return (
            <div>
                <div className={"cdb-blog-viewer"}>
                    <div className={"cdb-blog-viewer__posts"}>
                        {cards}
                    </div>
                    <div className={"cdb-blog-viewer__navigation"}>
                        {showNextPageButton ?  nextPageButton : null}
                    </div>
                </div>
            </div>
        );
    }
}